import { createHashRouter, createRoutesFromElements, Route } from 'react-router-dom';

import App from '@/features/app/App';
import { ErrorBoundary } from '@/features/app/ErrorBoundary';
import BatteryHistoryGraph from '@/features/batteryHistoryGraph/BatteryHistoryGraph';
import AssetBatteryData from '@/pages/AssetBatteryData';
import AssetsOverview from '@/pages/AssetsOverview';
import PackLevelDetailPage from '@/pages/PackLevelDetailPage';
import PackLevelOverviewPage from '@/pages/PackLevelOverviewPage';
import PackHistoryPage from '@/pages/PackHistoryPage';

export const router = createHashRouter(
    createRoutesFromElements(
        <Route path="/" element={<App />}>
            <Route path="/overview" errorElement={<ErrorBoundary />} element={<AssetsOverview />} />
            <Route path="/:assetId" errorElement={<ErrorBoundary />} element={<AssetBatteryData />} />
            <Route path="/dialog/:assetId" errorElement={<ErrorBoundary />} element={<BatteryHistoryGraph />} />
            <Route path="/dialog/pack-levels/:assetId" errorElement={<ErrorBoundary />} element={<PackLevelOverviewPage />} />
            <Route
                path="/dialog/pack-levels/:assetId/:packId"
                errorElement={<ErrorBoundary />}
                element={<PackLevelDetailPage />}
            />
            <Route path="/dialog/pack-history/:assetId" errorElement={<ErrorBoundary />} element={<PackHistoryPage />} />
        </Route>,
    ),
);
